import { RadioGroup, SelectBox, Template } from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { axiosGet } from "../../apis/useAxios";
import { DataGridSkeletonPageSimple } from "../skeleton/GridSkeleton";

export const shuttleTypeLst = [
  { id: 0, name: "All" },
  { id: 1, name: "Hotel Shuttle" },
  { id: 2, name: "Local Vender" },
  { id: 3, name: "Not Available" },
];

export default function AirportHotelLocationTransportMatrixComponent() {
  const [state, setState] = useState({
    isTransportMatrixApiLoading: false,
    isAirportDropdownApiLoading: false,
    transportMatrixGridLst: [],
    transportMatrixGridDataSource: [],
    filterAirportDropdownDataSource: [],
    filterAirportCode: "",
    shuttleTypeId: 0,
  });
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Transport Matrix`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isAirportDropdownApiLoading: true,
        }));
        await getFilterAirportDropdown();
        setState((prev) => ({
          ...prev,
          isAirportDropdownApiLoading: false,
        }));
      }, 0);
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isTransportMatrixApiLoading: true,
        }));
        await getTransportMatrixGridDataSource(state.filterAirportCode);
        setState((prev) => ({
          ...prev,
          isTransportMatrixApiLoading: false,
        }));
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getFilterAirportDropdown = async () => {
    try {
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode"
        )}`
      );
      setState((prev) => ({
        ...prev,
        filterAirportDropdownDataSource: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getTransportMatrixGridDataSource = async (airportCode) => {
    try {
      const response = await axiosGet(
        `HotelTransferContract/airport-hotel-location-transport-matrix`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: airportCode,
        }
      );
      let transportMatrixGridLst = response.payload ?? [];
      setState((prev) => ({
        ...prev,
        transportMatrixGridLst: transportMatrixGridLst,
      }));
      await filterTransMatrixDataGridShuttleTypeWise(
        state.shuttleTypeId,
        transportMatrixGridLst
      );
    } catch (error) {
      console.log(error);
    }
  };

  const filterTransMatrixDataGridShuttleTypeWise = async (
    shuttleTypeId,
    transportMatrixGridLst
  ) => {
    try {
      let transportMatrixGridDataSource = [
        ...new Set(
          transportMatrixGridLst?.filter(
            (f) =>
              shuttleTypeId === 0 ||
              (shuttleTypeId === 1 &&
                f.isShuttleAvailable === true &&
                f.isHotelShuttle === true) ||
              (shuttleTypeId === 2 &&
                f.isShuttleAvailable === true &&
                f.isHotelShuttle === false) ||
              (shuttleTypeId === 3 && f.isShuttleAvailable === false)
          )
        ),
      ];
      setState((prev) => ({
        ...prev,
        transportMatrixGridDataSource: transportMatrixGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          {state.isTransportMatrixApiLoading && <DataGridSkeletonPageSimple />}
          {!state.isTransportMatrixApiLoading && (
            <>
              <DataGrid
                ref={refDataGrid}
                dataSource={state.transportMatrixGridDataSource}
                showBorders={true}
                columnAutoWidth={true}
                allowColumnResizing={true}
                showRowLines={true}
                showColumnLines={true}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift(
                    {
                      location: "before",
                      template: "toolbarFilterAirportDropdown",
                    },
                    {
                      location: "before",
                      template: "toolbarShuttleTypeDrodown",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          try {
                            refDataGrid.current.instance.beginCustomLoading();
                            e.component.option(
                              "icon",
                              "fas fa-spinner fa-spin"
                            );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 500)
                            );
                            await getTransportMatrixGridDataSource();
                            refDataGrid.current.instance.endCustomLoading();
                            e.component.option("icon", "refresh");
                          } catch (error) {
                            console.log(error);
                          }
                        },
                      },
                    }
                  );
                }}
                onRowPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.rowElement.style.backgroundColor = "#f0f2f5";
                  }
                  if (e.rowType === "data") {
                    if (!e.data?.isShuttleAvailable) {
                      e.rowElement.style.backgroundColor = "#ffcccb";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    } else {
                      if (e.data?.isHotelShuttle) {
                        e.rowElement.style.backgroundColor = "#f5e6a2";
                      } else {
                        e.rowElement.style.backgroundColor = "#ccffcc";
                      }
                    }
                  }
                }}
              >
                <Column
                  dataField="airlineCode"
                  caption="Airline"
                  allowSearch={true}
                />
                <Column
                  dataField="airportName"
                  caption="Airport"
                  allowSearch={true}
                />
                <Column
                  dataField="fromLocation"
                  caption="From Location"
                  allowSearch={true}
                />
                <Column
                  dataField="toLocation"
                  caption="To Location"
                  allowSearch={true}
                />
                <Column
                  dataField="crewTypeName"
                  caption="Crew Type"
                  allowSearch={true}
                />
                <Column
                  dataField="shuttleProvider"
                  caption="Shuttle Provider"
                  allowSearch={true}
                />
                <Column
                  dataField="isShuttleAvailable"
                  caption="Shuttle Available"
                  allowFiltering={false}
                  allowSearch={true}
                />
                <Column
                  dataField="isHotelShuttle"
                  caption="Hotel Shuttle"
                  allowFiltering={false}
                  allowSearch={true}
                />
                <Column
                  dataField="transferType"
                  caption="Transfer Type"
                  allowSearch={true}
                />
                <Template
                  name="toolbarFilterAirportDropdown"
                  render={() => {
                    return (
                      <>
                        <SelectBox
                          dataSource={state.filterAirportDropdownDataSource}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select airport"
                          defaultValue={state.filterAirportCode}
                          displayExpr="airportName"
                          valueExpr="airportCode"
                          showClearButton={true}
                          searchEnabled={true}
                          width={300}
                          onValueChanged={async (e) => {
                            try {
                              refDataGrid.current.instance.beginCustomLoading();
                              let filterAirportCode = e.value ?? "";
                              setState((prev) => ({
                                ...prev,
                                filterAirportCode: filterAirportCode,
                              }));
                              await new Promise((resolve) =>
                                setTimeout(resolve, 500)
                              );
                              await getTransportMatrixGridDataSource(
                                filterAirportCode
                              );
                              refDataGrid.current.instance.endCustomLoading();
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        />
                        {state.isAirportDropdownApiLoading && (
                          <i
                            className="fas fa-spinner fa-spin text-green"
                            style={{
                              float: "right",
                              marginTop: "-22px",
                              marginRight: "12px",
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                />
                <Template
                  name="toolbarShuttleTypeDrodown"
                  render={() => {
                    return (
                      <>
                        <div className="dx-widget dx-collection">
                          <span style={{ fontSize: "1em", fontWeight: "bold" }}>
                            Shuttle Type
                          </span>
                          <div className="dx-field">
                            <RadioGroup
                              id="radio-group-with-selection"
                              items={shuttleTypeLst}
                              value={state.shuttleTypeId}
                              valueExpr="id"
                              displayExpr="name"
                              layout="horizontal"
                              onValueChanged={(e) => {
                                try {
                                  let shuttleTypeId = e.value ?? 1;
                                  setState((prev) => ({
                                    ...prev,
                                    shuttleTypeId: e.value,
                                  }));
                                  filterTransMatrixDataGridShuttleTypeWise(
                                    shuttleTypeId,
                                    state.transportMatrixGridLst
                                  );
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </>
                    );
                  }}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="AirportHotelLocationTransportMatrix"
                />
              </DataGrid>
            </>
          )}
        </div>
      </div>
    </>
  );
}
